import { render } from "./LoginLayout.vue?vue&type=template&id=c22a4db0"
import script from "./LoginLayout.vue?vue&type=script&lang=js"
export * from "./LoginLayout.vue?vue&type=script&lang=js"

import "./LoginLayout.vue?vue&type=style&index=0&id=c22a4db0&lang=scss"

import exportComponent from "/Users/perthpiti/InsightEra/ENOLA/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__